module.exports = __webpack_public_path__ + "img/needle-right2.3a75b598.png";